var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1357 12.0955C15.3385 12.2841 15.605 12.3888 15.8819 12.3888C16.1587 12.3888 16.4253 12.2841 16.628 12.0955L29.2875 0.343181C28.8627 0.148026 28.401 0.0460474 27.9334 0.0440941H3.83018C3.36258 0.0460505 2.90085 0.148032 2.47607 0.343181L15.1357 12.0955Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1189 13.7051C17.5092 14.2669 16.7107 14.5784 15.8817 14.5784C15.0527 14.5784 14.2542 14.2668 13.6445 13.7051L0.900504 1.87137C0.668913 2.32306 0.546637 2.82292 0.543457 3.33065V18.6691C0.543457 19.5409 0.889742 20.3768 1.50602 20.9933C2.12254 21.6096 2.95841 21.9559 3.83026 21.9559H27.9335C28.8053 21.9559 29.6412 21.6096 30.2577 20.9933C30.874 20.3768 31.2203 19.5409 31.2203 18.6691V3.33065C31.2171 2.82296 31.0948 2.32308 30.8633 1.87137L18.1189 13.7051Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.890ae84422ff47c71ce6a28b13b9615e.svg";
export { ForwardRef as ReactComponent };